import React from 'react';
import { Helmet } from 'react-helmet-async';

export const OrganizationStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Creanity",
    "alternateName": ["Creanity Teknoloji", "Creanity Technology", "Creanity Apps", "Creanity Software", "Creanity Mobile"],
    "description": "Yenilikçi mobil uygulamalar ve dijital çözümler geliştiren teknoloji şirketi",
    "url": "https://creanity.co",
    "logo": "https://creanity.co/images/logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "info@creanity.co",
      "contactType": "customer service",
      "availableLanguage": ["Turkish", "English"]
    },
    "sameAs": [
      "https://www.linkedin.com/company/creanity",
      "https://instagram.com/creanity_"
    ],
    "foundingDate": "2024",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Fenerbahçe Mah. İğrip Sk. No: 13 İç Kapı No: 1",
      "addressLocality": "Kadıköy",
      "addressRegion": "İstanbul",
      "addressCountry": "TR"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export const SoftwareApplicationStructuredData = ({ name, description, url, applicationCategory }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": name,
    "description": description,
    "url": url,
    "applicationCategory": applicationCategory,
    "operatingSystem": ["iOS", "Android", "Web"],
    "author": {
      "@type": "Organization",
      "name": "Creanity"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "TRY"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export const WebsiteStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Creanity",
    "description": "Yenilikçi mobil uygulamalar ve dijital çözümler",
    "url": "https://creanity.co",
    "publisher": {
      "@type": "Organization",
      "name": "Creanity"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}; 